import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProductData from './product-data/ProductData';
import ProductInventoryHeader from './product-inventory-header/ProductInventoryHeader';
import { ProductSearchSlider } from './product-search-slider/ProductSearchSlider';
import ProductTabs from './product-tabs/ProductTabs';
import InventoryBatches from '../InventoryBatches/InventoryBatches';
import InventoryBatchesData from '../../actions/tempdata/inventoryproductdata.json';
import { fetchTabData } from './productinventory.getdata.utils';
import { toggleInventoryBatch } from '../../actions/productInventory';
import { checkLoggedIn } from '../../utills';
import { useHistory , useLocation } from 'react-router';
import Button from 'jd-library/Button';
import BulkUpdateInventory from './bulkupdateinventory/BulkUpdateInventory';

function ProductInventory() {
  const state = useSelector((state) => state.productInventory);
  const token = useSelector((state) => state.session.token);
  const isMobile = useSelector((state) => state.deviceData.isMobile);
  const session = useSelector((state) => state.session);
  const location = useLocation();

  const dispatch = useDispatch();
  const [searchSlider, setSearchSlider] = useState(() => false);
  const [bulkUploadSlider, setBulkUploadSlider] = useState(() => false);
  const { viewinventorybatch: { showDiag, data: itemInfo } } = state;

  let history = useHistory();
	let { reduxSessionInit, loggedUser, noUserCheck } =
		session.user || {};
	const isUnauthorized = session.isUnauthorized;
	const showLoginBtn =
		reduxSessionInit &&
		!loggedUser &&
		!noUserCheck &&
		session.showCompanyDetails &&
		!isUnauthorized &&
		!session.isReadOnly;


  useEffect(() => {
    const { data, func } = fetchTabData(state);
    // if (!data) {
    dispatch(func());
    // }
  }, [state.currentTab]);

  useEffect(() => {
    const isInventoryDialogOpen = localStorage.getItem('isinventorydiag');
    const inventorydata = localStorage.getItem('inventorydata');
    if (!showDiag && isMobile && isInventoryDialogOpen) {
      dispatch(toggleInventoryBatch(JSON.parse(inventorydata)));
    }
  }, [isMobile]);

  useEffect(() => {
    const url = new URLSearchParams(location.search);
    const productId = url.get('product');
    if(location.search && productId){
     const inventorydata = InventoryBatchesData;
     dispatch(toggleInventoryBatch({...inventorydata,productId})) 
    }
  },[location.search])

  return (
    <div>
      <div>
        <ProductInventoryHeader 
          onSearch={() => setSearchSlider(() => true)}  
          onBulkUpdate={() => setBulkUploadSlider(() => true)}
          />
        <ProductTabs currentTab={state.currentTab} />
        <ProductData currentTab={state.currentTab} token={token} loggedIn={!showLoginBtn}/>
        {searchSlider && (
          <ProductSearchSlider
            onHidden={() => setSearchSlider(() => false)}
            token={token}
            currentTab={state.currentTab}
            loggedIn={!showLoginBtn}
          />)}
        {bulkUploadSlider && (
        <BulkUpdateInventory 
          onHidden={() => setBulkUploadSlider(() => false)} 
          /> 
        )}
        {showDiag &&
          (<InventoryBatches
            onHidden={() => {
              localStorage.removeItem('isinventorydiag');
              localStorage.removeItem('inventorydata');
              setTimeout(() =>{
                history.replace({ search: '' });
              },5);
              dispatch(toggleInventoryBatch());
            }}
            updateProduct={({ cb }) => { cb(); }}
            updateList={() => {
              const { func } = fetchTabData(state);
              dispatch(func());
            }}
            itemInfo={itemInfo}
            componentlabel="Edit Inventory"
            FromMarketPlaceInv={true}
          />)
        }
      </div>
      {showLoginBtn ? (
					<div className={'login-btn-holder'}>
						<Button
							className={'full-width-login-btn'}
							clickHandler={() => {
								// history.push('/products/auth');
								checkLoggedIn({ history, inventory: true });
							}}
						>
							{'Login'}
						</Button>
					</div>
				) : null}
    </div>
  )
}

export default memo(ProductInventory);